import AutoAwesomeIcon from "@mui/icons-material/AutoAwesomeOutlined";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router";

import { useAdvisor } from "src/advisor/AdvisorProvider";
import { SAFE_AREA_BOTTOM } from "src/components/AppShell/layout";
import { activeNavKey, MOBILE_TAB_KEYS, NAV_ITEMS } from "src/components/AppShell/navItems";

const ADVISOR_TAB = "advisor";

/** Mobile navigation (Figma "Tab bar"): the same destinations as the side nav, plus the advisor. */
export const BottomTabs: FC = () => {
	const { available: advisorAvailable, openAdvisor } = useAdvisor();
	const { t } = useTranslation();
	const { pathname } = useLocation();

	return (
		<Paper
			component="nav"
			aria-label={t("nav.primary")}
			square
			elevation={0}
			sx={{
				display: { md: "none" },
				position: "fixed",
				insetInline: 0,
				bottom: 0,
				zIndex: "appBar",
				borderTop: 1,
				borderColor: "divider",
				pb: SAFE_AREA_BOTTOM
			}}>
			<BottomNavigation showLabels value={activeNavKey(pathname) ?? false}>
				{NAV_ITEMS.filter(item => MOBILE_TAB_KEYS.includes(item.key)).map(({ key, to, icon: Icon, end }) => (
					<BottomNavigationAction
						key={key}
						value={key}
						label={t(`nav.short.${key}`)}
						icon={<Icon />}
						component={NavLink}
						to={to}
						end={end}
					/>
				))}
				{advisorAvailable && (
					<BottomNavigationAction
						value={ADVISOR_TAB}
						label={t("nav.short.advisor")}
						icon={<AutoAwesomeIcon />}
						onClick={openAdvisor}
					/>
				)}
			</BottomNavigation>
		</Paper>
	);
};
